import React, { useState, useEffect, } from 'react';
import eventBus from '@/utils/eventBus';
import { TableCell, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { SampleType } from '@/features/alojamientos/services/sampleTypeService';

interface Establishment {
  id: number;
  name: string;
  establishmentName: string;
  classId: string;
  localityId: string;
  region: string;
  phone: string;
  whatsapp: string;
  observations: string;
  statusId: string;
  capacity: number;
  sampleTypeId?: number;
}

interface Locality {
  id: number;
  name: string;
  departmentId: number;
  department: {
    id: number;
    name: string;
    regionId: number;
    region: {
      id: number;
      name: string;
    };
  };
}

interface TypeOption {
  id: number;
  name: string;
  segmentId: string;
  segment: {
    id: string;
    name: string;
  };
}

interface StatusOption {
  id: number;
  name: string;
}

interface EstablishmentRowProps {
  establishment: Establishment;
  isSelected: boolean;
  onSelect: (id: number, checked: boolean) => void;
  sampleTypes: SampleType[];
  assignment?: string;
  onAssignChange: (id: number, value: string) => void;
  selectedSampleType?: string;
  typeOptions: TypeOption[];
  localities: Locality[];
  statusOptions: StatusOption[];
}

const EstablishmentRow = ({ 
  establishment, 
  isSelected,
  onSelect, 
  sampleTypes, 
  typeOptions,
  localities,
  statusOptions
  
}: EstablishmentRowProps) => {

  const [checked, setChecked] = useState(isSelected);

  const handleChange = () => {
    console.log('📝 Cambio de checkbox para:', establishment.establishmentName);
    const newChecked = !checked;
    setChecked(newChecked);

    setTimeout(() => {
      console.log('⏰ Ejecutando onSelect para:', establishment.establishmentName);
      onSelect(establishment.id, newChecked as boolean);
    }, 0);
  };

  useEffect(() => {
    
    const handler = (newSampleId: string) => {
      console.log('📡 sampleId actualizado para:', establishment.establishmentName, 'nuevo ID:', newSampleId);
      if (
        establishment.sampleTypeId !== null &&
        establishment.sampleTypeId !== undefined &&
        newSampleId === establishment.sampleTypeId.toString()|| newSampleId.toString() ==='all'
      ) {
        setChecked(true);
      }else{
        setChecked(false);
      }
    };
    eventBus.on('sampleIdChange', handler);
    return () => {
      console.log('🧹 Desmontando EstablishmentRow para:', establishment.establishmentName);
      eventBus.off('sampleIdChange', handler);
    };
  }, []);

  return (
    <TableRow>
      <TableCell>
        <input
  type="checkbox"
  checked={checked}
  onChange={handleChange}
  aria-label={`Seleccionar ${establishment.name}`}
  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
/>
      </TableCell>
      <TableCell className="font-medium">{establishment.establishmentName}</TableCell>
      <TableCell>
        {typeOptions.find(type => type.id.toString() === establishment?.classId?.toString())?.name || establishment.classId}
      </TableCell>
      <TableCell>
        {establishment.localityId ? 
          localities.find(locality => locality.id.toString() === establishment.localityId.toString())?.name || establishment.localityId 
          : '-'}
      </TableCell>
      <TableCell>
        {establishment.localityId ? 
          localities.find(locality => locality.id.toString() === establishment.localityId.toString())?.department.region.name || '-'
          : '-'}
      </TableCell>
      <TableCell>{establishment.phone}</TableCell>
      <TableCell>{establishment.whatsapp}</TableCell>
      <TableCell>{establishment.observations}</TableCell>
      <TableCell>
        {statusOptions.find(status => status.id.toString() === establishment.statusId.toString())?.name || establishment.statusId}
      </TableCell>
      <TableCell>{establishment.capacity}</TableCell>
      <TableCell>
        {establishment.sampleTypeId 
          ? sampleTypes.find(type => type.id === establishment.sampleTypeId)?.name || '-'
          : '-'}
      </TableCell>
    </TableRow>
  );
};

export default EstablishmentRow; 